/// <amd-module name="Repos/Tfvc/Views/ChangesetsHub/RestClient/Tfvc" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   tfs\web\extensions\code\vss-code-web\repos\tfvc\views\changesets-hub\genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import * as Tfvc from "Repos/Common/Contracts/Git";

export interface ITfvcRestClient extends IVssRestClient {
    /**
     * Retrieve a Tfvc Changeset
     * 
     * @param id - Changeset Id to retrieve.
     * @param project - Project ID or project name
     * @param maxChangeCount - Number of changes to return (maximum 100 changes) Default: 0
     * @param includeDetails - Include policy details and check-in notes in the response. Default: false
     * @param includeWorkItems - Include workitems. Default: false
     * @param maxCommentLength - Include details about associated work items in the response. Default: null
     * @param includeSourceRename - Include renames.  Default: false
     * @param skip - Number of results to skip. Default: null
     * @param top - The maximum number of results to return. Default: null
     * @param orderby - Results are sorted by ID in descending order by default. Use id asc to sort by ID in ascending order.
     * @param searchCriteria - Following criteria available (.itemPath, .version, .versionType, .versionOption, .author, .fromId, .toId, .fromDate, .toDate) Default: null
     */
    getChangeset(id: number, project?: string, maxChangeCount?: number, includeDetails?: boolean, includeWorkItems?: boolean, maxCommentLength?: number, includeSourceRename?: boolean, skip?: number, top?: number, orderby?: string, searchCriteria?: Tfvc.TfvcChangesetSearchCriteria): Promise<Tfvc.TfvcChangeset>;
}

class TfvcRestClient extends RestClientBase implements ITfvcRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * Retrieve a Tfvc Changeset
     * 
     * @param id - Changeset Id to retrieve.
     * @param project - Project ID or project name
     * @param maxChangeCount - Number of changes to return (maximum 100 changes) Default: 0
     * @param includeDetails - Include policy details and check-in notes in the response. Default: false
     * @param includeWorkItems - Include workitems. Default: false
     * @param maxCommentLength - Include details about associated work items in the response. Default: null
     * @param includeSourceRename - Include renames.  Default: false
     * @param skip - Number of results to skip. Default: null
     * @param top - The maximum number of results to return. Default: null
     * @param orderby - Results are sorted by ID in descending order by default. Use id asc to sort by ID in ascending order.
     * @param searchCriteria - Following criteria available (.itemPath, .version, .versionType, .versionOption, .author, .fromId, .toId, .fromDate, .toDate) Default: null
     */
    public async getChangeset(
        id: number,
        project?: string,
        maxChangeCount?: number,
        includeDetails?: boolean,
        includeWorkItems?: boolean,
        maxCommentLength?: number,
        includeSourceRename?: boolean,
        skip?: number,
        top?: number,
        orderby?: string,
        searchCriteria?: Tfvc.TfvcChangesetSearchCriteria
        ): Promise<Tfvc.TfvcChangeset> {

        const queryValues: any = {
            maxChangeCount: maxChangeCount,
            includeDetails: includeDetails,
            includeWorkItems: includeWorkItems,
            maxCommentLength: maxCommentLength,
            includeSourceRename: includeSourceRename,
            '$skip': skip,
            '$top': top,
            '$orderby': orderby,
            searchCriteria: searchCriteria
        };

        return this.beginRequest<Tfvc.TfvcChangeset>({
            apiVersion: "5.0-preview.3",
            routeTemplate: "{project}/_apis/tfvc/changesets/{id}",
            routeValues: {
                project: project,
                id: id
            },
            queryParams: queryValues
        });
    }

}

export const TfvcClientName = "Repos.ChangesetsHub.Tfvc.ITfvcRestClient";

export function getTfvcClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): ITfvcRestClient {
    return pageContext.getRestClient<ITfvcRestClient>(TfvcClientName, options);
}

RestClients.add(TfvcClientName, { 
    factory: TfvcRestClient,
    options: {
        resourceAreaId: "8aa40520-446d-40e6-89f6-9c9f9ce44c48",
        serviceInstanceType: "00025394-6065-48ca-87d9-7f5672854ef7"
    }
});
